import React from 'react';
import {styled} from '@mui/material/styles';
import MaterialFormLabel from '@mui/material/FormLabel';
import type {FormLabelProps as MaterialFormLabelProps} from '@mui/material/FormLabel';

export interface FormLabelProps extends MaterialFormLabelProps {
    /**
     * Used to replace root node with different
     * component.
     */
    component?: React.ElementType<any>;
}

const StyledFormLabel = styled(MaterialFormLabel)(({theme}) => ({
    color: theme.palette.grey[900],
    '&.Mui-focused': {
        color: theme.palette.text.primary
    },
    marginBottom: theme.spacing(1),
    fontWeight: theme.typography.button.fontWeight,
    fontSize: theme.typography.button.fontSize
}));

export const FormLabel = React.forwardRef<any, FormLabelProps>(({
    children,
    ...props
}, ref) => (
    <StyledFormLabel
        ref={ref}
        {...props}
    >
        {children}
    </StyledFormLabel>
));

FormLabel.displayName = 'FormLabel';
